/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Leading_SpacesInputs */



/**
* | output |
* | --- |
* | "Remove Leading Spaces" |
*
* @param {Remove_Leading_SpacesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_leading_spaces = /** @type {((inputs?: Remove_Leading_SpacesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Leading_SpacesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer les espaces en début")
	if (locale === "de") return /** @type {LocalizedString} */ ("Führende Leerzeichen entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi gli spazi iniziali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалите пробелы в начале предложения.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar espacios iniciales")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除前导空格")
	if (locale === "ja") return /** @type {LocalizedString} */ ("先頭のスペースを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रारंभिक रिक्त स्थान हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover espaços iniciais")
	return /** @type {LocalizedString} */ ("Remove Leading Spaces")
});